import React, { useEffect, useRef, useState } from "react";
import TiltedCard from "./TiltedCard";
import MatrixHeading from "./MatrixHeading";
import "./Faculty.css";
import "./TiltedCard.css";

const Faculty = () => {
  const facultyMember = {
    name: "Dr. VENUGOPAL P",
    post: "Associate Dean, VIT Business School",
    image: "Coordinator/Venugopal.webp",
    alt: "Dr. Venugopal P, Associate Dean",
  };

  /* MatrixHeading reveal — fires when the Faculty section enters
     the viewport; resets when it leaves so it replays on re-entry. */
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.25 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="Faculty" ref={sectionRef}>
      <div className="fac-split">
        {/* LEFT — photo (opposite of Board) */}
        <div className="fac-left">
          <div className="fac-photo">
            <TiltedCard
              imageSrc={facultyMember.image}
              altText={facultyMember.alt}
              containerHeight="100%"
              containerWidth="100%"
              imageHeight="100%"
              imageWidth="100%"
              rotateAmplitude={10}
              scaleOnHover={1.05}
              showMobileWarning={false}
              showTooltip={false}
              displayOverlayContent={false}
            />
          </div>
        </div>

        {/* RIGHT — title block + faculty info */}
        <div className="fac-right">

          <h2 className="fac-main-heading">
            <MatrixHeading text="Coordinator" active={isVisible} />
          </h2>

          <p className="fac-tagline">
            <span className="fac-tagline-row">GUIDING</span>
            <span className="fac-tagline-row">VISION</span>
          </p>

          <div className="fac-heading-line" />

          <div className="fac-member-card">
            <div className="fac-member-info">
              <h3 className="fac-member-name">{facultyMember.name}</h3>
              <p className="fac-member-role">{facultyMember.post}</p>
            </div>
          </div>

          <p className="fac-mission-text">
            Mentoring IEEE TEMS VIT with experience and vision.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Faculty;
